__webpack_require__.p = "https://gestionminera.mp.gba.gob.ar/";